import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type ShopMenu = {
  shop_menu_id?: number; // 매장 메뉴 idx
  menu_id?: number; // 메뉴 idx
  shop_information_id?: number; // 매장 idx
  num?: number; // 수량
  menu_status?: string; // 메뉴 상태
  is_show?: string; // 노출여부
  order: number; // 노출 순서
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] ShopMenu
   * --
   */
  getShopMenus: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_SHOP_MENU, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] ShopMenu
   * --
   */
  getShopMenu: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_SHOP_MENU, {
        shop_menu_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ShopMenu
   * --
   */
  createShopMenu: async (body: ShopMenu) => {
    try {
      const res = await $http.post(APIConstant.CREATE_SHOP_MENU, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] ShopMenu
   * --
   */
  updateShopMenu: async (body: ShopMenu) => {
    try {
      const { shop_menu_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_SHOP_MENU, {
        shop_menu_id: shop_menu_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ShopMenu
   * --
   */
  deleteShopMenu: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_SHOP_MENU, {
        shop_menu_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
